import React from 'react';
import { Translation } from 'react-i18next';

export const TABS = {
  DETAILS: 'details',
  PRINCIPALS: 'users',
  PENDING_INVITATIONS: 'pending-invitations',
  JOIN_REQUESTS: 'join-requests',
  APP_SUBSCRIPTIONS: 'app-subscriptions',
  USER_GROUPS: 'user-groups',
  IDENTIFICATIONCODES: 'identificationcodes',
  COMMUNITIES: 'communities',
  DOCUMENTS_OVERVIEW: 'documents-overview',
  IMPERSONATION_REQUESTS: 'impersonation-requests',
};

export const PRINCIPAL_TABS = {
  DETAILS: 'details',
  ROLES: 'roles',
  ACCOUNTS: 'accounts',
  DOCUMENTS: 'documents',
};

export const DOCUMENT_ACTIONS = {
  UPLOAD: 'upload',
  PREVIEW: 'preview',
};

export const ACTIONS = {
  EDIT: 'edit',
  NEW: 'new',
};

export const CONTACT_ACTIONS = {
  CREATE_CONTACT: 'create-contact',
  REMOVE_CONTACT: 'remove-contact',
  EDIT_CONTACT: 'edit-contact',
};

export const USER_GROUP_ACTIONS = {
  EDIT: 'edit',
  NEW: 'new',
  MEMBERS: 'members',
};

export const PRINCIPAL_ACTIONS = {
  INVITE: 'invite',
  EDIT: 'edit',
  DETAILS: 'details',
  RESET: 'reset',
};

export const PRINCIPAL_FORM_NAME = 'principalForm';

export const PRINCIPAL_STATES = {
  ACTIVE: 1,
  INVITED: 2,
  DISABLED: 3,
  LOCKEDOUT: 4,
  DELETED: 5,
  PASSWORDTORESET: 6,
  PENDING: 7,
};

export const PRINCIPAL_STATES_OPTIONS = [
  {
    key: PRINCIPAL_STATES.ACTIVE,
    value: PRINCIPAL_STATES.ACTIVE,
    text: <Translation>{t => t('active')}</Translation>,
  },
  {
    key: PRINCIPAL_STATES.INVITED,
    value: PRINCIPAL_STATES.INVITED,
    text: <Translation>{t => t('invited')}</Translation>,
  },
  {
    key: PRINCIPAL_STATES.DELETED,
    value: PRINCIPAL_STATES.DELETED,
    text: <Translation>{t => t('deleted')}</Translation>,
  },
  {
    key: PRINCIPAL_STATES.PENDING,
    value: PRINCIPAL_STATES.PENDING,
    text: <Translation>{t => t('pending')}</Translation>,
  },
];

export const INFINITE_SCROLL = { loader: 'blocked' };

export const ORGANISATIONS_RESOURCE = 'organisations';
export const ORGANISATION_RESOURCE = 'organisation';
export const CREATE_ORGANISATION_RESOURCE = 'createOrganisation';
export const UPDATE_ORGANISATION_RESOURCE = 'updateOrganisation';
export const REMOVE_ORGANISATION_RESOURCE = 'removeOrganisation';

export const REMOVE_ORGANISATION_LOGO_RESOURCE = 'removeOrganisationLogo';

export const PRINCIPALS_RESOURCE = 'principals';
export const PRINCIPAL_RESOURCE = 'principal';
export const CREATE_PRINCIPAL_RESOURCE = 'createPrincipal';
export const UPDATE_PRINCIPAL_RESOURCE = 'updatePrincipal';
export const REMOVE_PRINCIPAL_RESOURCE = 'removePrincipal';

export const LINK_IDENTITY_RESOURCE = 'linkIdentity';
export const UNLINK_IDENTITY_RESOURCE = 'unlinkIdentity';

export const SEARCH_PRINCIPALS_RESOURCE = 'searchPrincipals';

export const AVAILABLE_ROLES_RESOURCE = 'availableRoles';

export const APP_SUBSCRIPTIONS_RESOURCE = 'appSubscriptions';
export const AVAILABLE_APP_SUBSCRIPTIONS_RESOURCE = 'availableAppSubscriptions';
export const CREATE_APP_SUBSCRIPTION_RESOURCE = 'createAppSubscription';
export const UPDATE_APP_SUBSCRIPTION_RESOURCE = 'updateAppSubscription';
export const REMOVE_APP_SUBSCRIPTION_RESOURCE = 'removeAppSubscription';

export const ORGANISATION_CONTACTS_RESOURCE = 'organisationContacts';
export const ORGANISATION_CONTACT_RESOURCE = 'organisationContact';
export const CREATE_ORGANISATION_CONTACT_RESOURCE = 'createOrganisationContact';
export const UPDATE_ORGANISATION_CONTACT_RESOURCE = 'updateOrganisationContact';
export const REMOVE_ORGANISATION_CONTACT_RESOURCE = 'removeOrganisationContact';

export const USER_GROUPS_RESOURCE = 'userGroups';
export const USER_GROUP_RESOURCE = 'userGroup';
export const CREATE_USER_GROUP_RESOURCE = 'createUserGroup';
export const UPDATE_USER_GROUP_RESOURCE = 'updateUserGroup';
export const REMOVE_USER_GROUP_RESOURCE = 'removeUserGroup';

export const ORGANISATION_USER_GROUPS_RESOURCE = 'organisationUserGroups';
export const ORGANISATION_USER_GROUPS_DETAILS_RESOURCE = 'organisationUserGroupsDetails';

export const USER_GROUP_MEMBERS_RESOURCE = 'userGroupMembers';
export const CREATE_USER_GROUP_MEMBER_RESOURCE = 'createUserGroupMember';
export const REMOVE_USER_GROUP_MEMBER_RESOURCE = 'removeUserGroupMember';

export const ORGANISATION_COMMUNITIES_RESOURCE = 'organisationCommunities';

export const JOIN_REQUESTS_RESOURCE = 'principalJoinRequests';
export const JOIN_REQUEST_RESOURCE = 'joinRequest';
export const ACCEPT_JOIN_REQUEST_RESOURCE = 'acceptJoinRequest';
export const DENY_JOIN_REQUEST_RESOURCE = 'denyJoinRequest';

export const APP_SUBSCRIPTION_ACTIONS = {
  NEW: 'new',
  NEW_FEATURE: 'new-feature',
  EDIT_FEATURE: 'edit-feature',
};

export const JOIN_REQUEST_ACTIONS = {
  ACCEPT_JOIN_REQUEST: 'accept-join-request',
  EDIT_JOIN_REQUEST: 'edit-join-request',
};

export const IMPERSONATION_REQUEST_ACTIONS = {
  VIEW: 'view-impersonation-request',
};

export const PENDING_INVITATIONS_RESOURCE = 'pendingInvitations';
export const RESEND_INVITATION_RESOURCE = 'resendInvitation';

export const GLOBAL_COMMUNITY_OPTION = {
  value: 'GLOBAL',
  key: 'GLOBAL',
  text: <Translation>{t => t('global')}</Translation>,
};

export const ASSIGNED_ROLES_TYPES = {
  USER_GROUP: 'UserGroup',
  PRINCIPAL_ROLE: 'PrincipalRole',
};

export const ASSIGNMENT_MODES = {
  MANUAL: 1,
  IDP: 2,
};

export const PRINCIPAL_DOCUMENTS_RESOURCE = 'principalDocuments';
export const DOCUMENT_TYPES_RESOURCE = 'documentTypes';
export const ORGANISATION_DOCUMENTS_RESOURCE = 'organisationDocuments';

export const DOCUMENT_STATUSES = {
  PENDING: 'Pending',
  VALIDATED: 'Validated',
  EXPIRED: 'Expired',
  SUPERSEDED: 'Superseded',
  REJECTED: 'Rejected',
  EXPIRING: 'Expiring',
};

export const DOCUMENT_STATUS_LABEL_OPTIONS = [
  { value: DOCUMENT_STATUSES.PENDING, color: 'yellow', key: 'pending' },
  { value: DOCUMENT_STATUSES.VALIDATED, color: 'green', key: 'validated' },
  { value: DOCUMENT_STATUSES.EXPIRED, color: 'red', key: 'expired' },
  { value: DOCUMENT_STATUSES.SUPERSEDED, color: 'grey', key: 'superseded' },
  { value: DOCUMENT_STATUSES.REJECTED, color: 'grey', key: 'rejected' },
  { value: DOCUMENT_STATUSES.EXPIRING, color: 'orange', key: 'expiring' },
];

export const DOCUMENT_UPLOAD_FORM_NAME = 'documentUpload';

export const DOCUMENT_MODAL_TYPES = {
  PREVIEW: 'preview',
  HISTORY: 'history',
};

export const FILTER_SETTINGS = {
  defaults: {},
};

export const DOCUMENT_TYPE_OPTIONS = [
  {
    key: 'CompanyEmployeeRegistration',
    value: 'CompanyEmployeeRegistration',
    text: <Translation>{t => t('documentType_CompanyEmployeeRegistration')}</Translation>,
  },
  {
    key: 'AirportAccreditation',
    value: 'AirportAccreditation',
    text: <Translation>{t => t('documentType_AirportAccreditation')}</Translation>,
  },
  {
    key: 'Passport',
    value: 'Passport',
    text: <Translation>{t => t('documentType_Passport')}</Translation>,
  },
  {
    key: 'DriverLicense',
    value: 'DriverLicense',
    text: <Translation>{t => t('documentType_DriverLicense')}</Translation>,
  },
  {
    key: 'IDCard',
    value: 'IDCard',
    text: <Translation>{t => t('documentType_IDCard')}</Translation>,
  },
];

export const DOCUMENT_FILTER_SETTINGS = {
  defaults: { includeHistory: true },
  convertor: ({ principalFullName, ...filters }) => ({
    ...filters,
    ...(principalFullName !== undefined && { PrincipalName: principalFullName }),
  }),
};

export const DOCUMENT_SORT_SETTINGS = {
  defaults: { expirationDate: 'asc' },
};

export const DOCUMENT_STATUS_OPTIONS = [
  {
    key: 0,
    value: 0,
    text: <Translation>{t => t('pending')}</Translation>,
  },
  {
    key: 1,
    value: 1,
    text: <Translation>{t => t('validated')}</Translation>,
  },
  {
    key: 2,
    value: 2,
    text: <Translation>{t => t('expiring')}</Translation>,
  },
  {
    key: 3,
    value: 3,
    text: <Translation>{t => t('expired')}</Translation>,
  },
];
